import React from 'react';
import './WhyChooseUs.css';
import { FaHandHoldingHeart, FaMicroscope, FaMoneyBillWave, FaTeeth } from 'react-icons/fa';
import DentalComparisonSection from './DentalComparisonSection';
// First, import useNavigate from react-router-dom at the top of your file
import { useNavigate } from 'react-router-dom';

// Then, inside your component function, add this before the return statement:

const WhyChooseUs = () => {
    const navigate = useNavigate();

    // Replace your current handleButtonClick function with this:
    const handleButtonClick = () => {
        navigate('/contact');
    };
    return (
        <>
            <section className='why-choose-us'>
                <div className='why-container'>
                    <div className='why-content'>
                        <span className='subtitle'>Reason To Choose Us</span>
                        <h2 className='title'>Why Choose Wisdom Dental Clinics Over Other Clinics?</h2>

                        <p className='description'>
                            At Wisdom Dental Clinic, we believe that a healthy, confident smile can change your life! Our expert dentists
                            provide gentle, pain-free treatments using the latest technology, ensuring the best care for you and your
                            family. Whether you need teeth whitening, braces, implants, or a complete smile makeover, we offer affordable,
                            personalized solutions tailored to your needs.
                        </p>

                        <p className='additional-text'>
                            With a hygienic, comfortable environment and easy appointment booking, achieving your dream smile has never been
                            easier.
                        </p>

                        <button className='appointment-btn' onClick={handleButtonClick}>
                            Book an Appointment
                        </button>
                    </div>

                    <div className='why-image'>
                        {/* <img src='chooseus-w.jpeg' alt='Dental Treatment Session' /> */}
                        <DentalComparisonSection />
                    </div>
                </div>

                <div className='features-container'>
                    <div className='feature'>
                        <div className='feature-icon'>
                            <FaTeeth className='icon' size={50} />
                        </div>
                        <h3>Experienced Dental Team</h3>
                        <p>
                            Led by <b>Dr. Muskan</b>, our specialists provide expert, compassionate care.
                        </p>
                    </div>

                    <div className='feature'>
                        <div className='feature-icon'>
                            <FaHandHoldingHeart className='icon' size={50} />
                        </div>
                        <h3>Best Care of Patients</h3>
                        <p>Your comfort and satisfaction are our top priorities.</p>
                    </div>

                    <div className='feature'>
                        <div className='feature-icon'>
                            <FaMoneyBillWave className='icon' size={50} />
                        </div>
                        <h3>Affordable Dental Care</h3>
                        <p>Competitive pricing with flexible payment options.</p>
                    </div>

                    <div className='feature'>
                        <div className='feature-icon'>
                            <FaMicroscope className='icon' size={50} />
                        </div>
                        <h3>State-of-the-Art Technology</h3>
                        <p>Advanced equipment for pain-free and precise treatments.</p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhyChooseUs;
